import { render, staticRenderFns } from "./BugTrackerDetailsComment.vue?vue&type=template&id=4b6bc724&scoped=true&"
import script from "./BugTrackerDetailsComment.vue?vue&type=script&lang=ts&"
export * from "./BugTrackerDetailsComment.vue?vue&type=script&lang=ts&"
import style0 from "./BugTrackerDetailsComment.vue?vue&type=style&index=0&id=4b6bc724&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6bc724",
  null
  
)

export default component.exports